import { render, staticRenderFns } from "./inline_blame_popover.vue.js?vue&type=template&id=f4181afa&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./inline_blame_popover.vue?vue&type=template&id=f4181afa&vue3"
import script from "./inline_blame_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./inline_blame_popover.vue?vue&type=script&lang=js&vue3"
export * from "./inline_blame_popover.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./inline_blame_popover.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports